/* eslint-disable no-debugger */
/* eslint-disable no-unused-vars */
/* eslint-disable no-lone-blocks */
/* eslint-disable no-console */
/* eslint-disable jsx-a11y/no-static-element-interactions */
/* eslint-disable max-len */
/* eslint-disable jsx-a11y/click-events-have-key-events */
/* eslint-disable jsx-a11y/no-noninteractive-element-interactions */
/* eslint-disable no-undef */
import React, { useState } from 'react';
import { CamelCase } from '../../../redux/helper/CamelCase';
import { InitialIcon } from '../../../redux/helper/IconGenerator';
import { InitialMaker } from '../../../redux/helper/InitialMaker';
import ThreeDotsLoader from '../../../Components/LoadingDots';

export default function RolesModal({
    rolesParams, setModalType, PopupRoles, setrolesParams, DistributorData, setDistributorData, handleUpdate, loading, setloading, capitalizeFirstLetter,
}) {
    const [searchShow, setsearchShow] = useState(false);
    const [tempValue, settempValue] = useState(DistributorData.SUPPORTS);
    const stringMaker = (val) => {
        let str = '';
        val.forEach((item) => {
            str += `${item},`;
        });
        return str;
    };
    const handleCheck = (email) => {
        const idx = tempValue.map((val) => val.EMAIL).indexOf(email);
        return idx > -1;
    };
    const handleAddRole = (item) => {
        const arr = [...tempValue];
        const idx = tempValue.map((val) => val.EMAIL).indexOf(item.email);
        if (idx > -1) {
            arr.splice(idx, 1);
        } else {
            arr.push({
                EMAIL: item.email,
                EMPLOYEE_CODE: item.employee_code,
                FIRST_NAME: item.first_name,
                LAST_NAME: item.last_name,
                ROLES: item.roles,
                PRODUCT_CATEGORIES: item.product_categories,
                PHONE_NUMBER: item.phone_number,
            });
        }
        settempValue(arr);
    };
    const handleLength = () => {
        const arr = [];
        if (tempValue.length > 0) {
            tempValue.forEach((val) => {
                if ((val?.roles?.toLowerCase().replace('business', 'sales')) === rolesParams.type || val?.ROLES?.toLowerCase().replace('business', 'sales') === rolesParams.type.toLowerCase().replace('business', 'sales')) {
                    arr.push(val);
                }
            });
        }
        return arr.length;
    };
    return (
        <div className="modal-dialog modal-dialog-centered relative w-auto pointer-events-none min-w-[441px]">

            <div
                className="modal-content border-none shadow-lg relative flex flex-col w-full pointer-events-auto bg-white bg-clip-padding rounded-md outline-none text-current"
            >
                <div className="modal-header flex flex-shrink-0 items-center justify-center py-5 rounded-t-md relative">
                    <h5 className="text-lg font-semibold text-[#090406]" id="exampleModalScrollableLabel">
                        Add
                        {' '}
                        {['area_sales_engineer'].includes(rolesParams.type) ? capitalizeFirstLetter(rolesParams.type) : capitalizeFirstLetter(rolesParams.type).replace('Sales', 'Business')}
                        (
                        {rolesParams.shortcut}
                        )
                    </h5>
                    <button
                        onClick={() => setModalType('')}
                        type="button"
                        data-bs-dismiss="modal"
                        aria-label="Close"
                        className="absolute top-[18px] right-[18px]"
                    >
                        <img
                            src="/images/Component1587.svg"
                            alt="icon"
                            className="w-3 h-3"
                        />
                    </button>
                </div>
                <div className="modal-body relative py-[18px] pl-10 px-[23px]">
                    <div className={`flex justify-end click-search absolute ${searchShow ? 'hidden' : ''}`} onClick={() => setsearchShow(!searchShow)}>
                        <input
                            type="text"
                            placeholder="Search"
                            className="h-7 w-[82px] pl-3 py-1 outline-0 placeholder:text-sm placeholder:font-normal placeholder:text-[#555259]"
                            onChange={(e) => {
                                setrolesParams((prevState) => ({
                                    ...prevState,
                                    search: e.target.value,
                                }));
                            }}
                        />
                        <img src="/images/search.svg" alt="icon" className="cursor-pointer" />
                    </div>
                    <div className={`flex items-center w-full ${searchShow ? '' : 'hidden'} search`}>
                        <div className="relative w-full">
                            <input
                                type="text"
                                id="search"
                                onChange={(e) => {
                                    setrolesParams((prevState) => ({
                                        ...prevState,
                                        search: e.target.value,
                                    }));
                                }}
                                className="px-3.5 h-[52px]  w-full rounded-lg outline-0 border border-[#B1B4B7] bg-[#FFFFFF] sm:text-lg text-base font-normal text-[#090406]"
                                autoComplete="off"
                            />
                            <label htmlFor="search" className="text-xs5  font-normal text-[#000000] absolute -top-0.5 left-3 px-1 bg-[#FFFFFF]">
                                Search
                                {' '}
                                {rolesParams.shortcut}
                                {' '}
                                Name/
                                {rolesParams.shortcut}
                                {' '}
                                Employee Code
                            </label>
                        </div>
                        <img src="/images/search.svg" alt="icon" className="absolute top-[38px] right-[68px]" />
                        <img
                            src="/images/Component1587.svg"
                            alt="icon"
                            className="w-3 h-3 ml-3.5 cursor-pointer close-search"
                            onClick={() => {
                                setsearchShow(!searchShow);
                                if (searchShow) {
                                    setrolesParams((prevState) => ({
                                        ...prevState,
                                        search: '',
                                    }));
                                }
                            }}
                        />
                    </div>
                    <div className="rounded-lg bg-[#F5F5FA] p-4 mt-3.5 h-[438px] overflow-auto dropdown-menu">
                        <p className="text-xs12 font-semibold text-[#A1A1A1] text-right">
                            {rolesParams.search === '' ? (
                                <>
                                    {handleLength()}
                                    {' '}
                                    selected
                                </>
                            ) : (
                                <>
                                    {' '}
                                    Results
                                    {' '}
                                    {' '}
                                    {PopupRoles.length}
                                </>
                            )}
                        </p>
                        {PopupRoles.length > 0 ? PopupRoles.map((role, i) => (
                            <div className="w-full" key={role.email}>
                                <div className="relative checkbox custom-checkbox custom-checkbox2 pb-4 flex">
                                    <input type="checkbox" id={`checkbox-111${role.employee_code}-${i}`} onChange={() => handleAddRole(role)} checked={handleCheck(role.email)} />
                                    <InitialIcon initials={InitialMaker(role.first_name, role.last_name)} widthValue="26" heightValue="26" font="15" />
                                    <label htmlFor={`checkbox-111${role.employee_code}-${i}`} className="text-lg font-normal  text-[#555259] pl-2">
                                        {role.first_name}
                                        {' '}
                                        {role.last_name}
                                        {' '}
                                        <span className="text-xs12 font-semibold text-[#A1A1A1]">{role.employee_code}</span>
                                        {' '}
                                        <span className="text-xs12 font-semibold text-[#A1A1A1]">{stringMaker(role.product_categories)}</span>
                                    </label>
                                </div>
                            </div>
                        )) : (
                            <div className="flex justify-center items-center">
                                <h1>
                                    No
                                    {' '}
                                    {' '}
                                    {CamelCase(rolesParams.type?.replace(/_/g, ' '))}
                                    {' '}
                                    found!
                                    {' '}
                                </h1>
                            </div>
                        )}

                    </div>
                    {
                        PopupRoles.length > 0
                        && (
                            <div className="flex justify-center mt-2 mb-4">
                                <button
                                    disabled={handleLength() === 0}
                                    onClick={() => handleUpdate(tempValue, 'SUPPORTS')}
                                    type="button"
                                    className="h-[42px] w-[168px] flex rounded-lg bg-[#555259] py-3 text-xs6 font-semibold text-[#FFFFFF] add-ase justify-center items-center"
                                    data-bs-dismiss="modal"
                                    aria-label="Close"
                                >
                                    {loading ? <ThreeDotsLoader /> : 'Add'}
                                </button>
                            </div>
                        )
                    }
                </div>
                {' '}

            </div>
        </div>
    );
}
